import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark2Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCheckmark2Small"><Path fillRule="evenodd" clipRule="evenodd" d="M17.825 7.12008C18.0349 7.2996 18.0594 7.61523 17.8799 7.82506L10.1799 16.8251C10.0887 16.9317 9.95686 16.9951 9.81661 16.9997C9.67636 17.0044 9.5406 16.9499 9.4425 16.8496L6.1425 13.4746C5.94944 13.2771 5.953 12.9606 6.15044 12.7675C6.34789 12.5744 6.66445 12.578 6.8575 12.7755L9.77539 15.7597L17.1201 7.17496C17.2996 6.96513 17.6152 6.94056 17.825 7.12008Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark2Small;
